const DEFAULT_BOTTOM_MODAL_STYLE_CONFIG = () => ({
  overlay: {
    display: "flex",
    justifyContent: "center",
    alignItems: "normal",
    width: "100vw",
    height: "100svh",
    overflowY: "auto",
    padding: "0"
  },
  content: {
    position: "unset",
    padding: "0",
    height: "auto",
    maxHeight: "90%",
    minHeight: "auto",
    maxWidth: "100%",
    width: "100%",
    overflowY: "auto",
    margin: "auto 0 0 0",
    borderRadius: "12px 12px 0 0"
  }
});
const DEFAULT_MODAL_STYLE_CONFIG = () => ({
  content: {
    height: "auto",
    maxHeight: "90%",
    width: "470px",
    maxWidth: "95%",
    overflow: "auto",
    backgroundColor: "transparent",
    boxShadow: "unset",
    padding: 0,
    borderRadius: 16
  }
});

export { DEFAULT_BOTTOM_MODAL_STYLE_CONFIG, DEFAULT_MODAL_STYLE_CONFIG };
//# sourceMappingURL=index.js.map
